import React from "react";
import { Box } from "@mui/material";
import CampaignTemplatePreviewContent from "./CampaignTemplatePreviewContent";

export default function CampaignTemplatePreviewCard({
  campaignTemplatePreviews,
  activeTemplateId,
  selectedTemplatePreview,
  hasConfiguredTemplates,
  isLoadingTemplatePreview,
  onSelectTemplate,
}) {
  return (
    <Box
      sx={{
        height: { xs: 360, sm: 380, lg: 396 },
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <CampaignTemplatePreviewContent
        hasConfiguredTemplates={hasConfiguredTemplates}
        isLoading={isLoadingTemplatePreview}
        selectedTemplatePreview={selectedTemplatePreview}
        campaignTemplatePreviews={campaignTemplatePreviews}
        activeTemplateId={activeTemplateId}
        onSelectTemplate={onSelectTemplate}
      />
    </Box>
  );
}
